/*
 * Custom Color Family Tabs
 * Standalone web component — unified card design.
 */

if (!window.cfpCustomActiveStates) {
  window.cfpCustomActiveStates = {};
}

class ColorFamilyTabsCustom extends HTMLElement {
  connectedCallback() {
    const form = this.closest('form[data-type="add-to-cart-form"]');
    this.formId = form ? form.id : 'default';
    this.tabs = this.querySelectorAll('.cfp__tab');
    this.swatches = this.querySelectorAll('.cfp__swatch[data-cfp-tone]');
    this.selectedLabel = this.closest('.cfp')?.querySelector('[data-cfp-selected-label]');

    if (this.tabs.length === 0 || this.swatches.length === 0) return;

    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.onTabClick.bind(this));
    });

    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        const name = swatch.dataset.cfpColorName;
        if (name && this.selectedLabel) {
          this.selectedLabel.textContent = name;
        }
        this.scrollToGallery();
      });
    });

    const radios = this.querySelectorAll('input[type="radio"]');
    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        const label = radio.nextElementSibling;
        if (label && label.dataset.cfpColorName && this.selectedLabel) {
          this.selectedLabel.textContent = label.dataset.cfpColorName;
        }
        this.swatches.forEach(s => s.classList.remove('is-selected'));
        if (label) label.classList.add('is-selected');
        this.scrollToGallery();
      });
    });

    if (form) {
      form.addEventListener('variant:change', () => {
        setTimeout(() => {
          const activeTab = this.resolveActiveTab();
          if (activeTab) this.activateTab(activeTab);
        }, 10);
      });
    }

    const activeTab = this.resolveActiveTab();
    if (activeTab) this.activateTab(activeTab);
  }

  resolveActiveTab() {
    const savedTone = window.cfpCustomActiveStates[this.formId];
    const selected = this.querySelector('input:checked + .cfp__swatch[data-cfp-tone]');

    if (selected) {
      const tones = (selected.dataset.cfpTone || '').split(' ').filter(Boolean);

      if (savedTone && tones.includes(savedTone)) {
        const btn = Array.from(this.tabs).find(t => t.dataset.cfpTone === savedTone);
        if (btn) return btn;
      }

      if (tones.length > 0) {
        const btn = Array.from(this.tabs).find(t => tones.includes(t.dataset.cfpTone));
        if (btn) return btn;
      }
    }

    return this.querySelector('.cfp__tab.is-active') || this.tabs[0];
  }

  scrollToGallery() {
    const gallery = document.querySelector('product-gallery');
    if (gallery) {
      gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  onTabClick(event) {
    this.activateTab(event.currentTarget);
  }

  activateTab(tab) {
    if (!tab) return;

    const tone = tab.dataset.cfpTone;
    const isNewTone = window.cfpCustomActiveStates[this.formId] !== tone;
    window.cfpCustomActiveStates[this.formId] = tone;

    this.tabs.forEach(t => t.classList.remove('is-active'));
    tab.classList.add('is-active');

    this.swatches.forEach(swatch => {
      const swatchTones = (swatch.dataset.cfpTone || '').split(' ').filter(Boolean);
      const input = swatch.previousElementSibling;

      if (swatchTones.includes(tone)) {
        swatch.removeAttribute('hidden');
        swatch.style.display = '';
        if (input && input.tagName === 'INPUT') input.style.display = '';

        // Re-trigger fade-in animation on tab switch
        if (isNewTone) {
          swatch.style.animation = 'none';
          swatch.offsetHeight; // force reflow
          swatch.style.animation = '';
        }
      } else {
        swatch.setAttribute('hidden', '');
        swatch.style.display = 'none';
        if (input && input.tagName === 'INPUT') input.style.display = 'none';
      }
    });
  }
}

if (!customElements.get('color-family-tabs-custom')) {
  customElements.define('color-family-tabs-custom', ColorFamilyTabsCustom);
}